export default __webpack_public_path__ + "static/media/Amanita13.dc8fb3a8.jpg";